import React, { useRef } from 'react';
import { useIsMobile } from '../utils/hooks';
import { Circle, Icon, IconButton, Image, Pressable, View } from 'native-base';
import FeatherIcon from 'react-native-vector-icons/dist/Feather';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper';

const ArrowButton = ({ isRight = false, onPress = () => {} }) => {
    const swiper = useSwiper();

    return (
        <Pressable
            position={'absolute'}
            top={0}
            left={isRight ? null : 0}
            right={isRight ? 0 : null}
            paddingX={'8'}
            height={'full'}
            justifyContent={'center'}
            onPress={() => {
                if (isRight) {
                    swiper.slideNext();
                } else {
                    swiper.slidePrev();
                }
            }}
            zIndex={10}>
            <Circle
                backgroundColor={'white'}
                size={'7'}
                justifyContent={'center'}
                alignItems={'center'}>
                <Icon
                    size={'5'}
                    as={FeatherIcon}
                    name={isRight ? 'chevron-right' : 'chevron-left'}
                    color={'lightText'}
                />
            </Circle>
        </Pressable>
    );
};

export default props => {
    const { data = [], renderItem = () => {}, onSnapToItem = () => {} } = props;

    const isMobile = useIsMobile();

    return (
        <View width={'full'}>
            <Swiper
                allowTouchMove={isMobile}
                autoplay={
                    data.length > 1
                        ? {
                              disableOnInteraction: false,
                              delay: 4000,
                          }
                        : false
                }
                autoHeight={true}
                loop={true}
                slidesPerView={1}
                style={{ width: '100%' }}
                modules={[Autoplay]}
                onRealIndexChange={swiper => {
                    onSnapToItem(swiper.realIndex);
                }}>
                {data.map((item, index) => (
                    <SwiperSlide key={index}>
                        {renderItem({ item, index })}
                    </SwiperSlide>
                ))}
                {!isMobile && data.length > 1 && (
                    <>
                        <ArrowButton />
                        <ArrowButton isRight />
                    </>
                )}
            </Swiper>
        </View>
    );
};

/*
export default (props) => {
    const {
        data = [],
        renderItem = () => {},
        onSnapToItem = () => {},
    } = props;


    const sliderRef = useRef();

    const isMobile = useIsMobile();

    return (
        <View>
            <Splide
                ref={sliderRef}
                options={{
                    pagination: false,
                    arrows: false,
                    autoplay: true,
                    type: 'loop',
                }}
                onMove={(_, index) => {
                    onSnapToItem(index);
                }}
            >
                {data.map((item, index) => <SplideSlide key={index}>{renderItem({ item, index })}</SplideSlide>)}
            </Splide>
            {(!isMobile && data.length > 1) &&
            <>
                <ArrowButton onPress={() => {
                    sliderRef.current.go('<');
                }}/>
                <ArrowButton isRight onPress={() => {
                    sliderRef.current.go('>');
                }}/>
            </>
            }
        </View>
    );
}
*/
/*
export default = (props) => {
    const {
        data = [],
        renderItem = () => {},
        onSnapToItem = () => {},
    } = props;

    const isMobile = useIsMobile();

    const sliderRef = useRef();

    return (
        <View>
            <Slider
                ref={sliderRef}
                infinite={true}
                afterChange={(index) => {
                    onSnapToItem(index);
                }}
                autoplay={true}
                pauseOnHover={false}
                swipe={isMobile}
                arrows={false}
            >
                {data.map((item, index) => <React.Fragment key={index}>{renderItem({ item, index })}</React.Fragment>)}
            </Slider>
            {(!isMobile && data.length > 1) &&
            <>
                <ArrowButton onPress={() => {
                    sliderRef.current.slickPrev();
                }}/>
                <ArrowButton isRight onPress={() => {
                    sliderRef.current.slickNext();
                }}/>
            </>
            }
        </View>
    )
};
*/
